import React from 'react'

import styles from './_section-header.module.scss'
import { Icon, Tooltip, type TooltipProps } from '../../../module'

export type SectionHeaderProps = {
  /** Title of the section */
  title: string
  /** Optional JSX that appears in the right side of the component */
  rightDisplay?: React.ReactNode
  /** Optional tooltip that appears next to the title */
  tooltip?: Omit<TooltipProps, 'children'>
  /** Optional prop to add a test id to the SectionHeader for QA testing */
  qaTestId?: string
}

const SectionHeader = ({
  title,
  rightDisplay,
  tooltip,
  qaTestId = 'section-header',
}: SectionHeaderProps): React.JSX.Element => {
  return (
    <div className={styles.container} qa-test-id={qaTestId}>
      <div className={styles.leftSection}>
        <span className={styles.title}>{title}</span>
        {tooltip ? (
          <Tooltip {...tooltip}>
            <Icon icon='info' color='dark-blue' iconSize='12px' />
          </Tooltip>
        ) : null}
      </div>
      {rightDisplay}
    </div>
  )
}

export default SectionHeader
